import {
  GET_EMPLOYEE_ALL_ROWS,
  GET_EMPLOYEE_ALL_ROWS_SUCCESS,
  ADD_EMPLOYEE_RECORD,
  ADD_EMPLOYEE_RECORD_SUCCESS,
  REMOVE_EMPLOYEE_RECORD,
  UPDATE_EMPLOYEE_RECORD,
  PUSH_EMPLOYEE_NEW_RECORD,
} from "./actionType"

const INIT_STATE = {
  employees: [],
  loading: false,
}

const EmployeeR = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_ALL_ROWS: {
      return {
        ...state,
        loading: true,
      }
    }
    case ADD_EMPLOYEE_RECORD:
    case REMOVE_EMPLOYEE_RECORD:
      return {
        ...state,
        loading: true,
      }
    case ADD_EMPLOYEE_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case PUSH_EMPLOYEE_NEW_RECORD:
      return {
        ...state,
        loading: false,
        employees: [
          ...(Array.isArray(state.employees) ? state.employees : []),
          action.payload.data.data,
        ],
      }
    case GET_EMPLOYEE_ALL_ROWS_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: action.payload.data,
      }
    case UPDATE_EMPLOYEE_RECORD: {
      const isArray = Array.isArray(state.employees)
      const list = isArray ? state.employees : (state.employees?.rows || [])
      const updatedList = list.map(item => {
        if (
          action.payload.isType == "status" &&
          item.id == action.payload.data.id
        ) {
          return { ...item, status: action.payload.data.status?.toString() }
        } else if (item.id == action.payload.data.id) {
          return {
            ...item,
            ...action.payload.data,
          }
        }
        return item
      })

      return {
        ...state,
        loading: false,
        employees: isArray
          ? updatedList
          : { ...state.employees, rows: updatedList },
      }
    }
    default:
      return state
  }
}

export default EmployeeR
